import { normalize } from "normalizr";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
    FORUM_ARCHIVE_CAMPAIGNS_LOAD,
    ForumArchivedCampaignsFetchNormalizedResponse,
    ForumArchivedCampaignsLoadAction,
    forumArchivedCampaignsFetch,
} from "@/mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.actions";
import { ArchivedCampaignsSchema } from "@/mk2/apps/forum/schemas";
import { XHRAction, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { forum_api_archive_campaigns_url } from "@/mk/urls/functions";

const logger = getLogger("forum/ArchivedCampaigns.sagas");

function* fetchArchivedCampaigns({ xhr }: ForumArchivedCampaignsLoadAction & XHRAction) {
    yield put(forumArchivedCampaignsFetch.request());

    try {
        const response = yield call(() => xhr.get(forum_api_archive_campaigns_url()));

        const normalizedResponse: ForumArchivedCampaignsFetchNormalizedResponse = normalize(
            response.body,
            {
                campaigns: [ArchivedCampaignsSchema],
            },
        );

        yield put(forumArchivedCampaignsFetch.success(normalizedResponse));
    } catch (error) {
        logger.error(error);
        yield put(forumArchivedCampaignsFetch.failure(normalizeError(error)));
    }
}

export default function* root() {
    yield all([takeLatest(FORUM_ARCHIVE_CAMPAIGNS_LOAD, fetchArchivedCampaigns)]);
}
